import _, * as _4 from 'lodash4';

angular.module('biz-ng-requisite-tree', []);

import 'utility-ng-interface';
import './core';

export * from './servants/course_requirement_tree';
export * from './servants/course_requirement_servant';
export * from './directives/add_attr';

export default 'biz-ng-requisite-tree';



// WEBPACK FOOTER //
// ./app/vendor/biz-ng-requisite-tree/src/main.ts